import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"

export async function getLicensePlates(selectedChannelUuids = [], selectedCameraUuids = [], selectedCameras = [], startTimestamp = null, endTimestamp = null, filterLicensePlates = [], listType = null, area = null, chineseName = null, englishName = null, company = null, department = null, employeeNumber = null, pageNo = null, pageOffset = null) {
  const licensePlateApi = "/v1/licensePlates";
  let licensePlates = []

  let data = {};

  if (selectedChannelUuids.length > 0) {
    data.selected_channel_uuids = JSON.stringify(selectedChannelUuids);
  }

  if (selectedCameraUuids.length > 0) {
    data.selected_camera_uuids = JSON.stringify(selectedCameraUuids);
  }

  if (selectedCameras.length > 0) {
    data.selected_cameras = JSON.stringify(selectedCameras);
  }

  if (startTimestamp != null && endTimestamp != null) {
    data.start_time = startTimestamp
    data.end_time = endTimestamp
  }

  if (filterLicensePlates.length > 0) {
    for (let i = 0; i < filterLicensePlates.length; i++) {
      filterLicensePlates[i] =
        filterLicensePlates[i].toUpperCase();
    }
    data.filter_license_plates = JSON.stringify(filterLicensePlates);
  }

  if (listType != null) {
    data.list_type = listType
  }

  if (area != null) {
    data.area = area
  }

  if (chineseName != null) {
    data.chinese_name = chineseName
  }

  if (englishName != null) {
    data.english_name = englishName
  }

  if (company != null) {
    data.company = company
  }

  if (department != null) {
    data.department = department
  }

  if (employeeNumber != null) {
    data.employee_number = employeeNumber
  }

  if (pageNo != null && pageOffset != null) {
    data.page_no = pageNo
    data.page_offset = pageOffset
  }


  await axios
    .get(licensePlateApi, { params: data })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("licensePlateNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.license_plates != undefined) {
        licensePlates = response.data.license_plates
      }
    })

  return licensePlates
}

export async function updateLicensePlate(data) {
  const licensePlateApi = "/v1/licensePlates";

  await axios
    .put(licensePlateApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("licensePlateNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function removeLicensePlate() {
  const licensePlateApi = "/v1/licensePlates";

  await axios
    .delete(licensePlateApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("licensePlateNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function getLicensePlateCount() {
  const licensePlateApi = "/v1/licensePlates/count";
  let licensePlateCount = {}

  await axios
    .get(licensePlateApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("licensePlateNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.current != undefined) {
        licensePlateCount.current = response.data.current
      }

      if (response.data.avaliable != undefined) {
        licensePlateCount.avaliable = response.data.avaliable
      }
    })

  return licensePlateCount
}

export async function getLicensePlateRawImages(selectedLicensePlateUuids = []) {
  const licensePlateApi = "/v1/licensePlates/rawImage";

  let data = {};

  if (selectedLicensePlateUuids.length > 0) {
    data.selected_license_plate_uuids = JSON.stringify(selectedLicensePlateUuids);
  }

  await axios
    .get(licensePlateApi, { params: data, responseType: "arraybuffer" })
    .catch((error) => {
      let decoder = new TextDecoder()
      let resData = decoder.decode(error.response.data)
      try {
        resData = JSON.parse(resData)
      }
      catch {
        //pass
      }

      if (resData.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("licensePlateNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: resData.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      let rawImage = response.data
      let blob = new Blob([rawImage], {
        type: "application/zip",
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      let fileName = "rawImage.zip";
      link.download = fileName;
      link.click();
    })
}